function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import './combo-segment-selection.scss';
import { getClassNames } from '../../utils/getClassNames';
import { simpleSort } from '../../utils/sorting';
import { Select, Switch, Skeleton } from 'antd';
import { SegmentSource } from '../../enums/segment-source';
var defaultSelectionValue = {
  allSubscribers: true
};

var ComboSegmentSelection = /*#__PURE__*/function (_React$Component) {
  _inherits(ComboSegmentSelection, _React$Component);

  var _super = _createSuper(ComboSegmentSelection);

  function ComboSegmentSelection(props) {
    var _this;

    _classCallCheck(this, ComboSegmentSelection);

    _this = _super.call(this, props);
    _this.iSegmentsRef = void 0;
    _this.xSegmentsRef = void 0;

    _this.handleSegmentsSearch = function (search) {
      var _this$props$onSearch, _this$props;

      (_this$props$onSearch = (_this$props = _this.props).onSearch) === null || _this$props$onSearch === void 0 ? void 0 : _this$props$onSearch.call(_this$props, search);
    };

    _this.handleXSegmentsEnabledChange = function (xSegmentsEnabled) {
      _this.setState({
        xSegmentsEnabled: xSegmentsEnabled
      });

      var value = _this.currentValue;
      value.excludedSegmentIds = xSegmentsEnabled ? [] : undefined;

      _this.emitChange(value);
    };

    _this.handleISegmentsChange = function (segmentIds) {
      segmentIds = segmentIds.filter(function (id) {
        return id.toString() !== 'new';
      });
      var value = _this.currentValue;
      value.segmentIds = segmentIds;

      _this.emitChange(value);
    };

    _this.handleXSegmentsChange = function (segmentIds) {
      segmentIds = segmentIds.filter(function (id) {
        return id.toString() !== 'new';
      });
      var value = _this.currentValue;
      value.excludedSegmentIds = segmentIds;

      _this.emitChange(value);
    };

    var propsValue = _this.props.value;
    var propsOptions = _this.props.options;
    var propsOptionsIsLoader = typeof propsOptions === 'function';
    var hasStaticOptions = !!propsOptions && !propsOptionsIsLoader;
    _this.state = {
      loading: hasStaticOptions !== null && hasStaticOptions !== void 0 ? hasStaticOptions : true,
      options: hasStaticOptions ? propsOptions : [],
      value: _this.currentValue,
      xSegmentsEnabled: propsValue ? !!_this.currentValue.excludedSegmentIds : false
    };
    return _this;
  }

  _createClass(ComboSegmentSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resolveOptions().then();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$switchSiz;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          hideIncluded = _this$props2.hideIncluded,
          hideExcluded = _this$props2.hideExcluded,
          size = _this$props2.size,
          className = _this$props2.className,
          includedLabel = _this$props2.includedLabel; // Antd Switch only has 'small' | 'default'

      var switchSize = (_this$props$switchSiz = this.props.switchSize) !== null && _this$props$switchSiz !== void 0 ? _this$props$switchSiz : size === 'small' ? 'small' : 'default';
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select', className, "size-".concat(size), "switch-size-".concat(switchSize), _defineProperty({
          disabled: disabled
        }, 'with-excluded', !hideExcluded))
      }, !hideIncluded && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select-isegs')
      }, includedLabel !== false && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select-isegs-label')
      }, includedLabel !== null && includedLabel !== void 0 ? includedLabel : 'Include subscribers in any of the following segments', ":"), this.renderSegmentSelect('included')), !hideExcluded && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select-xsegs')
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select-xsegs-toggle', 'switch-row', _defineProperty({}, 'enabled', this.state.xSegmentsEnabled))
      }, /*#__PURE__*/React.createElement("div", {
        className: "switch-left"
      }, /*#__PURE__*/React.createElement(Switch, {
        size: switchSize,
        disabled: disabled,
        checked: this.state.xSegmentsEnabled,
        onChange: this.handleXSegmentsEnabledChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "switch-right"
      }, "Exclude segments")), this.state.xSegmentsEnabled && this.renderSegmentSelect('excluded'))));
    }
  }, {
    key: "renderSegmentSelect",
    value: function renderSegmentSelect(type) {
      var _this2 = this;

      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          notFoundContent = _this$props3.notFoundContent,
          stickyOptionRenderer = _this$props3.stickyOptionRenderer;
      var value = this.currentValue;

      var isMatch = function isMatch(needle, haystack) {
        return (haystack !== null && haystack !== void 0 ? haystack : []).includes(needle.value);
      };

      var enabledIds = type === 'included' ? value.segmentIds : value.excludedSegmentIds;
      var disabledIds = type === 'included' ? value.excludedSegmentIds : value.segmentIds;
      var currentSelectedIds = [].concat(_toConsumableArray(enabledIds !== null && enabledIds !== void 0 ? enabledIds : []), _toConsumableArray(disabledIds !== null && disabledIds !== void 0 ? disabledIds : []));
      var visibleOptions = this.state.options.filter(function (o) {
        var isSelectedOrIsNotAdhoc = o.source !== SegmentSource.ADHOC || currentSelectedIds.includes(o.value);
        return !o.isDefault && isSelectedOrIsNotAdhoc;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: getClassNames('combo-segment-select-dd-wrapper', type)
      }, /*#__PURE__*/React.createElement(Skeleton, {
        active: true,
        loading: this.state.loading,
        avatar: false,
        title: false,
        paragraph: {
          rows: 1
        }
      }, /*#__PURE__*/React.createElement(Select, {
        ref: function ref(el) {
          return type === 'included' ? _this2.iSegmentsRef = el : _this2.xSegmentsRef = el;
        },
        className: getClassNames('combo-segment-select-dd', type),
        dropdownClassName: getClassNames('combo-segment-select-dd-options', type),
        disabled: disabled,
        size: this.props.size,
        mode: "multiple",
        loading: this.state.loading,
        onChange: type === 'included' ? this.handleISegmentsChange : this.handleXSegmentsChange,
        onSearch: this.handleSegmentsSearch,
        value: enabledIds,
        placeholder: "Select at least one segment to ".concat(type.replace(/d$/, '')),
        notFoundContent: notFoundContent === null || notFoundContent === void 0 ? void 0 : notFoundContent(type),
        optionFilterProp: "title",
        optionLabelProp: "title",
        filterOption: true
      }, stickyOptionRenderer === null || stickyOptionRenderer === void 0 ? void 0 : stickyOptionRenderer(type), visibleOptions.map(function (o) {
        var _o$key, _o$label;

        return /*#__PURE__*/React.createElement(Select.Option, {
          key: (_o$key = o.key) !== null && _o$key !== void 0 ? _o$key : o.value,
          disabled: isMatch(o, disabledIds),
          value: o.value,
          title: o.title
        }, (_o$label = o.label) !== null && _o$label !== void 0 ? _o$label : o.value);
      }))));
    }
  }, {
    key: "currentValue",
    get: function get() {
      var _ref, _this$props$value, _this$state;

      var currValue = (_ref = (_this$props$value = this.props.value) !== null && _this$props$value !== void 0 ? _this$props$value : (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.value) !== null && _ref !== void 0 ? _ref : defaultSelectionValue;
      return _objectSpread({}, currValue);
    }
  }, {
    key: "emitChange",
    value: function emitChange(value) {
      var _this$props$onChange, _this$props4;

      this.setState({
        value: value
      });
      (_this$props$onChange = (_this$props4 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props4, value);
    }
  }, {
    key: "unpackOptions",
    value: function () {
      var _unpackOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opts) {
        var _yield$opts, _yield$opts2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof opts === 'function')) {
                  _context.next = 15;
                  break;
                }

                _context.next = 3;
                return opts();

              case 3:
                _context.t2 = _yield$opts = _context.sent;
                _context.t1 = _context.t2 !== null;

                if (!_context.t1) {
                  _context.next = 7;
                  break;
                }

                _context.t1 = _yield$opts !== void 0;

              case 7:
                if (!_context.t1) {
                  _context.next = 11;
                  break;
                }

                _context.t3 = _yield$opts;
                _context.next = 12;
                break;

              case 11:
                _context.t3 = [];

              case 12:
                _context.t0 = _context.t3;
                _context.next = 32;
                break;

              case 15:
                if (!(_typeof(opts) === 'object' && 'then' in opts)) {
                  _context.next = 30;
                  break;
                }

                _context.next = 18;
                return opts;

              case 18:
                _context.t6 = _yield$opts2 = _context.sent;
                _context.t5 = _context.t6 !== null;

                if (!_context.t5) {
                  _context.next = 22;
                  break;
                }

                _context.t5 = _yield$opts2 !== void 0;

              case 22:
                if (!_context.t5) {
                  _context.next = 26;
                  break;
                }

                _context.t7 = _yield$opts2;
                _context.next = 27;
                break;

              case 26:
                _context.t7 = [];

              case 27:
                _context.t4 = _context.t7;
                _context.next = 31;
                break;

              case 30:
                _context.t4 = opts;

              case 31:
                _context.t0 = _context.t4;

              case 32:
                return _context.abrupt("return", _context.t0);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function unpackOptions(_x) {
        return _unpackOptions.apply(this, arguments);
      }

      return unpackOptions;
    }()
  }, {
    key: "resolveOptions",
    value: function () {
      var _resolveOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var addtOptions, options, loadedOptions, _addtOptions$length;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  loading: true
                });
                _context2.next = 3;
                return this.unpackOptions(this.props.additionalOptions);

              case 3:
                addtOptions = _context2.sent;
                _context2.next = 6;
                return this.unpackOptions(this.props.options);

              case 6:
                options = _context2.sent;
                loadedOptions = [];

                if (options) {
                  if (((_addtOptions$length = addtOptions === null || addtOptions === void 0 ? void 0 : addtOptions.length) !== null && _addtOptions$length !== void 0 ? _addtOptions$length : 0) > 0) {
                    addtOptions.forEach(function (opt) {
                      if (!options.find(function (o) {
                        return o.value === opt.value;
                      })) {
                        options.push(opt);
                      }
                    });
                    options.sort(function (a, b) {
                      var _a$label, _b$label;

                      return simpleSort((_a$label = a.label) !== null && _a$label !== void 0 ? _a$label : a.value, (_b$label = b.label) !== null && _b$label !== void 0 ? _b$label : b.value);
                    });
                  }

                  loadedOptions = options;
                }

                this.setState({
                  loading: false,
                  options: loadedOptions
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resolveOptions() {
        return _resolveOptions.apply(this, arguments);
      }

      return resolveOptions;
    }()
  }]);

  return ComboSegmentSelection;
}(React.Component);

export default ComboSegmentSelection;